// Korkokirjaukset lainoille: Transaction-tyypit ja lainatyyppiset sijoituskohteet.
// Pidä samassa linjassa backendin transactions/choices.py (INTEREST_TX_TYPES) ja
// private_investment_funds/choices.py (LOAN_PIF_TYPES) kanssa.

export const INTEREST_TYPE = 33;             // Korko, rahana maksettu
export const INTEREST_CAPITALIZED_TYPE = 34; // Korko, pääomitettu lainaan
export const INTEREST_TYPES = [INTEREST_TYPE, INTEREST_CAPITALIZED_TYPE];

export const LOAN_FUND_TYPES = ["loans", "loans_listed", "own_loans"];

export const isLoanFundType = (fundType) => LOAN_FUND_TYPES.includes(fundType);

export const isInterestType = (type) => INTEREST_TYPES.includes(parseInt(type, 10));
